import * as React from 'react';
const SvgBuilding = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 0 .833 8.05v11.117H7.5v-6.259a2.5 2.5 0 0 1 5 .017v6.242h6.667V8.05zm7.917 17.917H13.7v-5a3.75 3.75 0 1 0-7.5 0v5H2.033v-9.3L10 1.667l7.917 6.95z" />
  </svg>
);
export default SvgBuilding;
